export function buildKey(impression) {
  return impression.keyName + ":" + impression.feature + ":" + impression.treatment + ":" + impression.label + ":" + impression.changeNumber;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/impressions/hasher/buildKey.js
// module id = 2833
// module chunks = 39